/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that returns an unlooped array without going over index
 *
 * @export
 * @class LoopUnrollPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'loopUnroll',
})
export class LoopUnrollPipe implements PipeTransform {
  /**
   * Takes an array of objects, the starting index and then the
   * amount of indicies you want to unroll from said index
   *
   * return if no value
   *
   * @param {Object[]} value
   * @param {number} startIndex
   * @param {number} unrollLength
   * @returns {Object[]}
   * @memberof LoopUnrollPipe
   */
  public transform(value: Object[], startIndex: number, unrollLength: number): Object[] {
    if (!value) {
      return [];
    }
    const objectArray: Object[] = [value[startIndex]];
    const arrayLength = value.length;

    for (let i = startIndex + 1; i < startIndex + unrollLength; i++) {
      if (i < arrayLength) {
        objectArray.push(value[i]);
      }
    }
    return objectArray;
  }
}
